import React from 'react';
import { CircularProgress } from '@mui/material';
import { connect } from 'react-redux';
import {
  Progress,
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Form,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Collapse,
  UncontrolledCollapse,
  UncontrolledTooltip,
  InputGroup,
  Alert,
} from 'reactstrap';
import ValidatedTextBox from '../ValidatedTextBox';
import { withAlert } from 'react-alert';
import { v4 as uuidv4 } from 'uuid';

class MultiSMTPConfigModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      alertMessage: '',
      alertType: '',
      settings: [],
      isLoading: false,
      folder: '',
      type: '',
      folders: [],
      smtpConfigs: [],
      settingsid: 0,
      emailConfig: ''
    };
  }

  componentDidMount() {
  this.formIsLoading();
  this.getX3Folders();
  this.getMultiSMTPDetails();
  this.loadSettings();
}

formIsLoading() {
  this.setState({ isLoading: true });
}

loadSettings() {
  const emailConfig = this.props.settings?.emailConfig;
  const fallbackSettings = this.props.settings || {};

  // Use nocache param to avoid stale response
  fetch(`/api/config/get_db_config_setting?emailConfig=${encodeURIComponent(emailConfig)}&nocache=${Date.now()}`)
    .then((res) => res.json())
    .then((result) => {
      const dbSettings = result?.[0]?.settings?.[0];

      if (dbSettings) {
        this.setState({
          settings: dbSettings,
          folder: dbSettings.folder || '',
          isLoading: false,
        });
      } else {
        // fallback if Mongo returns no results
        console.warn("No DB config found, using props fallback.");
        this.setState({
          settings: fallbackSettings,
          folder: fallbackSettings.folder || '',
          isLoading: false,
        });
      }
    })
    .catch((error) => {
      console.error("Fetch error, using props fallback:", error);
      this.setState({
        settings: fallbackSettings,
        folder: fallbackSettings.folder || '',
        isLoading: false,
      });
    });
}


  getMultiSMTPDetails = () => {
    fetch(
      window.location.protocol +
        "//" +
        window.location.host +
        "/api/config/get_db_config?type=smtp"
    )
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            smtpConfigs: result,
          });
        },
        (error) => {
          this.setState({
            error: true,
          });
        }
      );
  };

  getX3Folders = async () => {
    try {
      const r = await fetch(`${window.location.origin}/api/sageX3/get_x3_folders`, {
        headers: { "Accept": "application/json" }
      });

      const payload = await r.json();

      if (!r.ok) {
        console.error("get_X3_folders failed", payload);
        this.setState({ isLoading: false });
        return;
      }

      this.setState({
        folders: payload?.folders ?? [],
        isLoading: false
      });
    } catch (err) {
      console.error("get_X3_folders error", err);
      this.setState({ isLoading: false });
    }
  };

  attemptSave = async () => {
  
      const updatedSettings = {
        ...this.state.settings,
        settingsid: uuidv4(), // Update settingsid correctly
      };
  
      this.setState({
        loading: true,
      });
      try {
  
        const response = await fetch(`/api/config/set_db_config?id=${this.props.fileid}`, {
          method: 'POST',
          body: JSON.stringify({
            settings: updatedSettings,
            id: this.props.settingsId,
  
          }),
          headers: {
            'Content-Type': 'application/json',
          },
        });
  
        if (!response.ok) {
          throw new Error('Failed to save smtp settings');
        }
  
        this.setState({ settings: updatedSettings });
  
        this.props.refresh();
        this.props.toggle();
      }
      catch (error)
      {
        console.error('Save error:', error);
        logging.error("Error occured when attempting to save smtp settings." + error);
      }
      finally {
        this.setState({
          loading: false
        });
      }    
    };

  checkboxChange = (e) => {
    const target = e.target;
    const checked = target.checked;
    const name = target.name;

    var settings = { ...this.state.settings };
    settings[name] = checked;

    this.setState({
      settings,
    });
  };

  handleFolderDropdownChange = (event) => {
    const target = event.target;
    const value = target.value;

    this.setState((prevState) => ({
      folder: value,
      settings: {
        ...prevState.settings,
        folder: value,
      },
      alertMessage: '',
    }));
  };

handleTextChange = (e) => {
  if (!e || !e.target) {
    console.warn('Event or target is undefined:', e);
    return;
  }

  const { id, value } = e.target;
  let settings = { ...this.state.settings };
  settings[id] = value || '';

  if (id === 'port') {
    const rawValue = value.replace(/\D/g, '');
    const portValue = parseInt(rawValue, 10);

    if (!isNaN(portValue) && portValue <= 65535) {
      settings[id] = portValue;
    } else {
      settings[id] = '';
    }
  }

  if (id === 'type') {
    if (value === 'Office365') {
      settings.host = 'smtp.office365.com';
      settings.port = '587';
      settings.secure = '';
      settings.ignoreTLS = '';
      settings.requireTLS = '';
      settings.tenantId = '';
      settings.clientId = '';
      settings.clientSecret = '';
    } else if (value === 'SMTP') {
      settings.tenantId = '';
      settings.clientId = '';
      settings.clientSecret = '';
    } else if (value === 'MicrosoftGraph') {
      settings.host = '';
      settings.port = '';
      settings.secure = false;
      settings.ignoreTLS = false;
      settings.requireTLS = false;
    }
  }


  this.setState({
    settings,
  });
};


  sendTestEmail = async () => {
    
    const type  = this.state.settings.type.toLowerCase();
    
    const commonParams = {
      type: type,
      fromAddress: this.state.settings.emailFrom,
      replyToAddress : this.state.settings.replyTo,
      adminAddress: this.state.settings.admin_address,
      username: this.state.settings.username
    }

    let emailParams = {};

    if (type === 'smtp') {
      emailParams = {
        ...commonParams,
        server: this.state.settings.host,
        port: this.state.settings.port,
        host: this.state.settings.host,
        secure: this.state.settings.secure,
        ignoreTls: this.state.settings.ignoreTLS,
        requireTls: this.state.settings.requireTLS,
        tlsServername: this.state.settings.tlsServername,
        password: this.state.settings.password,
        bypassProxy: this.state.settings.bypassProxy || false,
      }
    }
    else if (type === 'office365'){
        emailParams = {
        ...commonParams,
        server: this.state.settings.host,
        port: this.state.settings.port,
        host: this.state.settings.host,
        password: this.state.settings.password,
      };
    }  
    else if (type === 'microsoftgraph'){
        emailParams = {
        ...commonParams,
        tenantId: this.state.settings.tenantId,
        clientId: this.state.settings.clientId,
        clientSecret: this.state.settings.clientSecret,
      };
    }

    this.setState({loading: true });

    try{
      const response = await fetch('/api/email/send_test_email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(emailParams),
      });

      const result = await response.json();

      if (result.error) {
        console.error('Error sending test email:', result.message);
        this.setState({ alertMessage: 'There was an error sending a test email.', alertType: 'danger' });
      } else {
        this.setState({ alertMessage: 'Test email was sent. It may take a few minutes to arrive.', alertType: 'success' });
      }
    }
    catch (error) {
      console.error('Network or server error:', error);
      
    }
    finally {
      this.setState({ loading: false });
      //this.props.refresh();
      //this.props.toggle();
    }
  };

  validationCheck = () => {

    // now that i have the smtp configs , we need to do some validation
    // find if the name already exists. check if the default settings already exist for this folder. etc.
    const settings = this.state.settings;
    const currentSettingsId = this.state.settings.settingsid;

    const foundNameConflict = this.state.smtpConfigs.settings.find(
      (item) => 
        item.emailConfig.trim().toLowerCase() === this.state.settings.emailConfig.trim().toLowerCase() 
        && item.settingsid !== currentSettingsId
    );

    if (foundNameConflict) {
      this.setState({ alertMessage: 'Record with this emailConfig name already exists.', alertType: 'danger' });
      return;
    }

    if (this.state.settings.isDefault) {
      const foundDefaultConflict = this.state.smtpConfigs.settings.find(
        (item) => 
          item.folder === this.state.settings.folder 
          && item.isDefault === true 
          && item.settingsid !== currentSettingsId
      );

      if (foundDefaultConflict) {
        this.setState({ alertMessage: 'There is already a default for this folder.', alertType: 'danger' });
        return;
      }
    }

    // Microsoft Graph validation
    if (settings.type === "MicrosoftGraph") {
      const { tenantId, clientId, clientSecret, username } = settings;

      if (!tenantId) {
        this.setState({ alertMessage: "Tenant id required. Please enter a value.", alertType: 'danger' });
        return; // Stop save here
      }
      if (!clientId) {
        this.setState({ alertMessage: "Application (client) id required. Please enter a value.", alertType: 'danger' });
        return; // Stop save here
      }
      if (!clientSecret) {
        this.setState({ alertMessage: "Client secret required. Please enter a value.", alertType: 'danger' });
        return; // Stop save here
      }
      if (!username) {
        this.setState({ alertMessage: "Username required. Please enter a value.", alertType: 'danger' });
        return; // Stop save here
      }

    }

      // General validation
    if (!settings.type) {
      this.setState({ alertMessage: 'Type required, please enter a value', alertType: 'danger' });
      return;
    }

    if (settings.type !== "MicrosoftGraph") {
      if (!settings.host) {
        this.setState({ alertMessage: 'Host required, please enter a value', alertType: 'danger' });
        return;
      }

      if (!settings.port) {
        this.setState({ alertMessage: 'Port required, please enter a value', alertType: 'danger' });
        return;
      }
    }

    if (!settings.folder) {
      this.setState({ alertMessage: 'Folder required, please enter a value', alertType: 'danger' });
      return;
    }

    if (!settings.emailFrom) {
      this.setState({ alertMessage: 'Email from required, please enter a value', alertType: 'danger' });
      return;
    }

    if (!settings.admin_address) {
      this.setState({ alertMessage: 'Admin email required, please enter a value' , alertType: 'danger' });
      return;
    }

    // All checks passed
    this.attemptSave();
  };

  isTestButtonEnabled = () => {
    const { settings } = this.state;

    if (!settings.type || !settings.emailFrom || !settings.admin_address) {
      return false;
    }

    const type = settings.type.toLowerCase();

    switch (type) {
      case 'smtp':
        return !!(settings.host && settings.port);               
      case 'office365':
        return (
          !!settings.host &&
          !!settings.port &&
          !!settings.username &&
          !!settings.password
        );

      case 'microsoftgraph':
        return (
          !!settings.tenantId &&
          !!settings.clientId &&
          !!settings.clientSecret &&
          !!settings.username
        );

      default:
        return false;
    }
  };

  isSaveButtonEnabled = () => {
    const { settings } = this.state;

    if (
      !settings.type ||
      !settings.folder ||
      !settings.emailFrom ||
      !settings.admin_address
    ) {
      return false;
    }

    const type = settings.type.toLowerCase();

    switch (type) {
      case 'smtp':
        return !!(settings.host && settings.port);           
      case 'office365':
        return (
          !!settings.host &&
          !!settings.port &&
          !!settings.username &&
          !!settings.password
        );

      case 'microsoftgraph':
        return !!(
          settings.tenantId &&
          settings.clientId &&
          settings.clientSecret &&
          settings.username
        );

      default:
        return false;
    }
  };

  render() {
    const { localisation } = this.props.userReducer;

    let folders = [];

    let alert_message = <div />;

    if (this.state.alertMessage) {
      alert_message = (
        <Alert color={this.state.alertType}>
          {this.state.alertMessage}
        </Alert>
      );
    }

    if (this.state.folders)
      this.state.folders.forEach((res) => {
        folders.push(<option>{res.DOSSIER}</option>);
      });

    return (
      <Modal
        isOpen={this.props.visible}
        toggle={this.props.toggle}
        className="modal-dialog"
      >
        <ModalHeader toggle={this.props.toggle}>Email Server Configuration</ModalHeader>
        <ModalBody>
          <Form>
            <div className="modal-view">
              <div className="modal-view-input">

              <Label for="configname" className="s-field-title s-anchored">
                  <span style={{ color: 'red' }}>*</span> Email Config Name:
                </Label>

                <Input
                  type="text"
                  onChange={this.handleTextChange}
                  id="emailConfig"
                  value={this.state.settings.emailConfig}
                ></Input>
                
                <FormGroup check style={{ marginTop: '25px' }}>
                  <Label for="isDefault" className="s-field-title s-anchored">
                    <Input
                      type="checkbox"
                      name="isDefault"
                      onClick={this.checkboxChange}
                      checked={this.state.settings.isDefault}
                    />{' '}
                    Set as Folder Default
                  </Label>
                </FormGroup>

                <br></br>

                {this.state.settings?.type && (
                  <>
                    <Label for="type" className="s-field-title s-anchored">
                      <span style={{ color: 'red' }}>*</span> Outgoing Server Type:
                    </Label>

                    <Input
                      type="select"
                      name="type"
                      id="type"
                      value={this.state.settings.type}
                      disabled
                    >
                      <option value="SMTP">SMTP</option>
                      <option value="MicrosoftGraph">Microsoft Graph</option>
                      <option value="Office365">Office365 (basic auth)</option>
                    </Input>

                    <p style={{ fontSize: '12px', color: '#6c757d', marginTop: '5px' }}>
                      The Server Type cannot be changed. Please create a new configuration if a change of type is required.
                    </p>

                    <br />
                  </>
                )}
               <br></br>

                {this.state.settings.type && (
                  <>

                    {this.state.settings.type === "MicrosoftGraph" && (
                      <>
                        <Label for="tenantId" className="s-field-title s-anchored">
                          <span style={{ color: 'red' }}>*</span> Tenant ID:
                        </Label>
                        <Input
                          type="text"
                          id="tenantId"
                          title="The unique identifier for your Azure AD directory (organization). It is found in the Azure Portal under Azure Active Directory → Overview → Directory (tenant) ID."
                          onChange={this.handleTextChange}
                          value={this.state.settings.tenantId || ""}
                        />
                        <p style={{ fontSize: '12px', color: '#6c757d', marginTop: '5px' }}>
                          The unique identifier for your Azure AD directory (organization). It is found in the Azure Portal under Azure Active Directory → Overview → Directory (tenant) ID.
                        </p>
                        <br />
  
                        <Label for="clientId" className="s-field-title s-anchored">
                          <span style={{ color: 'red' }}>*</span> Application ID:
                        </Label>
                        <Input
                          type="text"
                          id="clientId"
                          onChange={this.handleTextChange}
                          value={this.state.settings.clientId || ""}
                        />
                        <p style={{ fontSize: '12px', color: '#6c757d', marginTop: '5px' }}>
                          <bold>Application ID</bold> also known as Client ID is a unique identifier for your application registered in Azure Active Directory. You can find it in the Azure Portal under your app’s overview page (App Registration → Overview → Application (client) ID).
                        </p>
                        <br />
  
                        <Label for="clientSecret" className="s-field-title s-anchored">
                          <span style={{ color: 'red' }}>*</span> Client Secret:
                        </Label>
                        <Input
                          type="password"
                          id="clientSecret"
                          onChange={this.handleTextChange}
                          value={this.state.settings.clientSecret || ""}
                        />
                        <p style={{ fontSize: '12px', color: '#6c757d', marginTop: '5px' }}>
                          <bold>Secret value</bold> also known as client secret is a password-like key generated for your application in Azure AD. You can create a Client Secret in the Azure Portal under App Registration → Certificates & Secrets → New Client Secret. Keep it secure, as it provides access to your app’s permissions.
                        </p>
                        <br />
                      </>
                    )}

                    {this.state.settings.type !== "MicrosoftGraph" && (
                      <>
                        <Label for="host" className="s-field-title s-anchored">
                          <span style={{ color: 'red' }}>*</span> Server Hostname or IP:
                        </Label>

                        <Input
                          type="text"
                          onChange={this.handleTextChange}
                          id="host"
                          value={this.state.settings.host}
                        ></Input>

                        <br></br>

                      <Label for="port" className="s-field-title s-anchored">
                        <span style={{ color: 'red' }}>*</span> Server Port:
                      </Label>

                      <Input
                        type="number"
                        id="port"
                        min="1"
                        max="65535"
                        step="1"
                        onChange={this.handleTextChange}
                        value={this.state.settings.port}
                        style={{ width: '120px' }}
                      />

                      <p style={{ fontSize: '12px', color: '#6c757d', marginTop: '5px' }}>
                        Valid port range is <strong>1–65535</strong>.<br />
                        Common values are <strong>587</strong> for STARTTLS and <strong>465</strong> for SSL/TLS.<br />
                        For Office365 use port <strong>587</strong>.
                      </p>
                        <br></br>
                      </>
                    )}

                    <Label for="folder" className="s-field-title s-anchored">
                      <span style={{ color: 'red' }}>*</span> Sage X3 Folder:
                    </Label>

                    <Input
                      type="select"
                      name={'folder'}
                      onChange={this.handleFolderDropdownChange}
                      id="folder"
                      value={this.state.folder}
                    >
                      {folders}
                    </Input>

                    <br></br>

                    {this.state.settings.type !== "MicrosoftGraph" && this.state.settings.type !== "Office365" && (
                      <>
                          <FormGroup check style={{ marginTop: '25px' }}>
                          <Label for="secure" className="s-field-title s-anchored">
                          <Input
                            type="checkbox"
                            name="secure"
                            onClick={this.checkboxChange}
                            checked={this.state.settings.secure}
                          />{' '}
                          Secure
                          <p style={{ fontSize: '12px', color: '#6c757d', marginTop: '5px' }}>
                          Uncheck for STARTTLS on port 587 / Check for SSL/TLS on port 465. 
                          If using a different port, check your email provider's SMTP settings.<br />    
                        </p>
                        </Label>
                      </FormGroup>
                      <FormGroup check style={{ marginTop: '25px' }}>
                        <Label for="ignoreTLS" className="s-field-title s-anchored">
                          <Input
                            type="checkbox"
                            name="ignoreTLS"
                            onClick={this.checkboxChange}
                            checked={this.state.settings.ignoreTLS}
                          />{' '}
                          Ignore TLS
                          <p style={{ fontSize: '12px', color: '#6c757d', marginTop: '5px' }}>
                          Check this if the server does not support STARTTLS or TLS encryption is not required.  
                          This is typically used for unencrypted connections on port 25 or when troubleshooting. <br />
                            Use this setting when using the Fusion Mail Relay application.
                        </p>  
                        </Label>
                      </FormGroup>
                      <FormGroup check style={{ marginTop: '25px' }}>
                        <Label for="requiredTLS" className="s-field-title s-anchored">
                          <Input
                            type="checkbox"
                            name="requireTLS"
                            onClick={this.checkboxChange}
                            checked={this.state.settings.requireTLS}
                          />{' '}
                          Require TLS
                          <p style={{ fontSize: '12px', color: '#6c757d', marginTop: '5px' }}>
                          Check this to force TLS encryption even if the server does not explicitly advertise support.
                          Use this when security is critical, and you want to prevent unencrypted connections.<br />
                        </p>
                        </Label>
                      </FormGroup>
                      <br></br>
                      <Label for="tlsServerName" className="s-field-title s-anchored">
                        TLS Server Name:
                      </Label>

                      <Input
                        type="text"
                        onChange={this.handleTextChange}
                        id="tlsServerName"
                        value={this.state.settings.tlsServerName || ''}
                      ></Input>
                        <p style={{ fontSize: '12px', color: '#6c757d', marginTop: '5px' }}>
                        Specify the hostname for TLS verification if required to prevent certificate mismatch errors.
                        Typically, this should match the SMTP server address.
                        </p>

                      <FormGroup check style={{ marginTop: '25px' }}>
                        <Label for="bypassProxy" className="s-field-title s-anchored">
                          <Input
                            type="checkbox"
                            name="bypassProxy"
                            onClick={this.checkboxChange}
                            checked={this.state.settings.bypassProxy || false}
                          />{' '}
                          Bypass Proxy for this Server
                          <p style={{ fontSize: '12px', color: '#6c757d', marginTop: '5px' }}>
                            Check this to send email directly without going through the configured proxy.
                            Use this for local or internal SMTP servers (e.g. hMailServer) that are not reachable via the proxy.
                          </p>
                        </Label>
                      </FormGroup>
                    </>
                  )}
                  <br></br>

                  <Label for="username" className="s-field-title s-anchored">
                    {(this.state.settings.type !== "SMTP") && (
                      <span style={{ color: 'red' }}>*</span>
                    )}{' '}
                    Username:
                  </Label>

                  <Input
                    type="text"
                    onChange={this.handleTextChange}
                    id="username"
                    value={this.state.settings.username || ''}
                    required={this.state.settings.type !== "SMTP"}
                  />
                  <br />


                  {this.state.settings.type !== "MicrosoftGraph" && (
                    <>
                  <Label for="password" className="s-field-title s-anchored">
                    {this.state.settings.type === "Office365" && (
                      <span style={{ color: 'red' }}>*</span>
                    )}{' '}
                    Password:
                  </Label>
                  <Input
                    type="password"
                    onChange={this.handleTextChange}
                    id="password"
                    value={this.state.settings.password || ""}
                    placeholder="Enter password"
                    required={this.state.settings.type === "Office365"}
                  />
                    </>
                  )}
                  <br></br>
                    <Label for="emailFrom" className="s-field-title s-anchored">
                        <span style={{ color: 'red' }}>*</span> From Address:
                      </Label>
                    <Input
                        type="text"
                        onChange={this.handleTextChange}
                        id="emailFrom"
                        value={this.state.settings.emailFrom}
                      ></Input>
                      <p style={{ fontSize: '12px', color: '#6c757d', marginTop: '5px' }}>
                      Specify the From Address in the format of &quot;info@domain.com&quot;.<br />
                      To specify a From Name use the format &quot;From Name &lt;info@domain.com&gt;&quot;.<br />
                      This can also be configured in the Crystal Report using the From Tag.
                      <br /><br />
                    </p>
                      
                      <Label for="replyTo" className="s-field-title s-anchored">
                        Reply To Address:
                      </Label>

                      <Input
                        type="text"
                        onChange={this.handleTextChange}
                        id="replyTo"
                        value={this.state.settings.replyTo || ''}
                      ></Input>
                      <br></br>
                      <Label for="admin_address" className="s-field-title s-anchored">
                        <span style={{ color: 'red' }}>*</span> Admin Address:
                      </Label>

                      <Input
                        type="text"
                        onChange={this.handleTextChange}
                        id="admin_address"
                        value={this.state.settings.admin_address}
                      ></Input>
                      <br />
                  </>
                )}

              </div>
            </div>
          </Form>
          {alert_message}
        </ModalBody>
        <ModalFooter>
          <Button
            id="testButton"
            color="info"
            disabled={!this.isTestButtonEnabled()}
            onClick={this.sendTestEmail}
          >
            Test
          </Button>
          <UncontrolledTooltip placement="top" target="testButton">
            {!this.isTestButtonEnabled()
            ? 'Please complete required fields before testing.'
            : 'Send a test email to verify this configuration.'}
          </UncontrolledTooltip>
          <Button
            id="saveButton"
            color="primary"
            disabled={!this.isSaveButtonEnabled() || this.state.loading}
            onClick={this.validationCheck}
          >
            {this.state.loading ? (
              <CircularProgress
                style={{
                  width: '1.2rem',
                  height: '1.2rem',
                  borderWidth: '.1em',
                }}
              />
            ) : localisation['save_button'] ? (
              localisation['save_button'].element_lang
            ) : (
              ''
            )}
          </Button>
          <UncontrolledTooltip placement="top" target="saveButton">
            {!this.isSaveButtonEnabled()
            ? 'Please complete all required fields before saving.'
            : 'Save this configuration to the database.'}
          </UncontrolledTooltip>
          <Button
            id="cancelButton"
            color="secondary"
            onClick={this.props.toggle}
          >
            Close
          </Button>
          <UncontrolledTooltip placement="top" target="cancelButton">
            Cancel all changes without saving
          </UncontrolledTooltip>
        </ModalFooter>
      </Modal>
    );
  }
}

export default connect((state) => state)(withAlert()(MultiSMTPConfigModal));
